import { translate } from "@/domain/utils/translate";

/**
 * Librería de tipos de identificación
 */
export enum IdentificationTypes {
  RUT_TYPE = 1,
  PASSPORT_TYPE = 2,
  CC_TYPE = 3,
}

/**
 * Estructura de tipos
 */
export interface IIdentificationTypes {
  id: number;
  name: string;
}
/**
 * Lista de tipos de identificación.
 *
 * @Typedef {Object} IIdentificationTypes
 * @property {string} id - El ID del tipo de identificación.
 * @property {string} name - El nombre del tipo de identificación.
 */

/**
 * Lista de tipos de identificación disponibles.
 *
 * @type {IIdentificationTypes[]}
 */
const getTypeList = (): IIdentificationTypes[] => ([
  {
    id: IdentificationTypes.RUT_TYPE,
    name: translate('general.rut_type'),
  },
  {
    id: IdentificationTypes.PASSPORT_TYPE,
    name: translate('general.passport_type'),
  },
  {
    id: IdentificationTypes.CC_TYPE,
    name: translate('general.dni_type'),
  },
]);

export default getTypeList;
